import React from 'react';
import { useTranslation } from 'react-i18next';

// action -> { i18n label key, button variant }
const LABELS = {
  request: { key: 'flow.accept', variant: 'primary' },
  decline: { key: 'flow.decline', variant: 'secondary' },
  propose_time: { key: 'flow.propose_time', variant: 'primary' },
  agree_time: { key: 'flow.agree_time', variant: 'primary' },
  mark_here: { key: 'flow.im_here', variant: 'primary' },
  confirm_presence: { key: 'flow.confirm_presence', variant: 'primary' },
  dispute_presence: { key: 'flow.dispute_presence', variant: 'danger' },
  confirm_handoff: { key: 'flow.confirm_handoff', variant: 'primary' },
  report_no_show: { key: 'flow.report_no_show', variant: 'danger' },
  cancel: { key: 'flow.cancel', variant: 'secondary' },
  cancel_as_no_show: { key: 'flow.cancel_as_no_show', variant: 'danger' },
  mark_done: { key: 'flow.mark_done', variant: 'secondary' },
  admit_no_show: { key: 'flow.admit_no_show', variant: 'secondary' },
  dispute_no_show: { key: 'flow.dispute_no_show', variant: 'primary' },
};

/**
 * Renders the available flow actions as labelled buttons. `only` / `exclude`
 * narrow which actions a given card surfaces. `advance_leg` is intentionally
 * not in LABELS — it's an internal redirect handled by the engine.
 */
export default function ActionButtons({ actions = [], dispatch, busy = false, only = null, exclude = [] }) {
  const { t } = useTranslation('common');
  // Dedupe by action — a state can expose the same action via two transitions
  // (e.g. confirm_presence self-loops then completes). The button is enabled if
  // ANY of that action's transitions is currently guard-satisfied.
  const seen = new Set();
  const items = [];
  for (const a of actions) {
    if (!LABELS[a.action]) continue;
    if (only && !only.includes(a.action)) continue;
    if (exclude.includes(a.action)) continue;
    if (seen.has(a.action)) continue;
    seen.add(a.action);
    const guardOk = actions.some((x) => x.action === a.action && x.guardOk);
    items.push({ action: a.action, guardOk });
  }
  return items.map((a) => {
    const { key, variant } = LABELS[a.action];
    return (
      <button
        key={a.action}
        type="button"
        className={`flow-btn flow-btn--${variant}`}
        disabled={!a.guardOk || busy}
        data-action={a.action}
        onClick={() => dispatch(a.action)}
      >
        {t(key)}
      </button>
    );
  });
}
